import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Own constants/actions/components
import { getCarouselAction } from 'services/actions/carousel';
import { results, resultsItems } from 'services/selectors/carousel';
import Carousel from 'components/carousel';
import LoaderCP from 'components/loader';

const CarouselContainer = () => {
  const dispatch = useDispatch();
  const data = useSelector(results);
  const itemsResults = useSelector(resultsItems);

  useEffect(() => {
    dispatch(getCarouselAction());
  }, []);

  return (
    <div>
      { data.isFetching ? <LoaderCP /> : '' }
      { data.error ? '' : '' }
      { itemsResults && itemsResults.results && data.isFetching === false
        ? <Carousel items={itemsResults.results} />
        : '' }
    </div>
  );
};

export default CarouselContainer;
